import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNotification } from 'config/Notification';
import { getUserService } from 'services/modules/idp/user';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhone, faUser, faCheckCircle, faUsers, faTag } from '@fortawesome/free-solid-svg-icons';
import { Button, Card, CardHeader, CardContent, Divider, CircularProgress, Grid, Typography} from '@mui/material';
import AccountBoxIcon from '@mui/icons-material/AccountBox';

const MyProfile = () => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  const authenticateduserContainer = useSelector(state => state.auth.user);

  const { openNotification } = useNotification();

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await getUserService(authenticateduserContainer.id);
        setUserData(response);
      } catch (error) {
        openNotification('error', `Error fetching data: ${error.message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, [authenticateduserContainer.id, openNotification]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px', background: '#f9f9f9',height:'800px' }}>
          <div className="position-relative">
            {loading && (
              <div className="card-loader-overlay">
                <CircularProgress size={60} />
              </div>
            )}
      <Card style={{ maxWidth: '800px', width: '100%', padding: '20px', boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)' }}>
        <CardHeader
          title={
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <img src="/assets/userprofile.75163155.svg" alt="User Icon" style={{ height: '40px', marginRight: '10px' }} />
                <Typography variant="h5" style={{ fontWeight: 'bold' }}>Profile</Typography>
              </div>
              <Button
                variant="contained"
                color="primary"
                className="back font"
                onClick={() => window.history.back()}
              >
                Back
              </Button>
            </div>
          }
        />
        <Divider/>
        <CardContent>
            <Grid container spacing={3}>
              {/* Profile Picture */}
              <Grid item xs={12} sm={4} style={{ textAlign: 'center' }}>
                <AccountBoxIcon
                  style={{ width: '120px', height: '120px', margin: '0 auto' }}
                />
                <Typography variant="h6" style={{ marginTop: '10px', fontWeight: 'bold' }}>{userData?.name}</Typography>
                <Typography variant="body2" color="textSecondary">{userData?.username}</Typography>
              </Grid>

              {/* Profile Information */}
              <Grid item xs={12} sm={8}>
                <Grid container spacing={2}>
                  <Grid item xs={4}>
                    <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>
                      <FontAwesomeIcon icon={faUser} /> Name:
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <Typography variant="body1">{userData?.name}</Typography>
                  </Grid>
                   <Grid item xs={4}>
                    <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>
                     <FontAwesomeIcon icon={faTag} /> Username:
                    </Typography>
                 </Grid>
                   <Grid item xs={8}>
                     <Typography variant="body1">{userData?.username}</Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>
                      <FontAwesomeIcon icon={faEnvelope} /> Email:
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <Typography variant="body1">{userData?.email}</Typography>
                  </Grid>

                  <Grid item xs={4}>
                    <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>
                      <FontAwesomeIcon icon={faUsers} /> Role:
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <Typography variant="body1">
                      {userData?.roles.map((role, index) => (
                        <span key={index}>
                          {role?.label}
                          {index < userData?.roles?.length - 1 && ', '}
                        </span>
                      ))}
                    </Typography>
                  </Grid>

                  <Grid item xs={4}>
                    <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>
                      <FontAwesomeIcon icon={faPhone} /> Mobile:
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <Typography variant="body1">
                      {userData.mobile && `${userData?.mobile?.code} ${userData?.mobile?.digits}`}
                    </Typography>
                  </Grid>

                  <Grid item xs={4}>
                    <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>
                      <FontAwesomeIcon icon={faCheckCircle} /> Status:
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <Typography variant="body1" style={{ color: userData?.status === 'ACTIVE' ? 'green' : 'red' }}>
                          {userData?.status?.substring(0, 1).concat(userData?.status?.slice(1).toLowerCase())}
                  </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
        </CardContent>
      </Card>
      </div>
    </div>
  );
};

export default MyProfile;
